import algoliasearch from 'algoliasearch/lite'

export const testEnv = 'test'

export const algoliaAppId = process.env.NEXT_PUBLIC_ALGOLIA_APP_ID
export const algoliaSearchApiKey =
  process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_API_KEY
export const algoliaSearchIndexId = process.env.NEXT_PUBLIC_ALGOLIA_INDEX_ID

export const algoliaSearchClient = algoliasearch(
  algoliaAppId,
  algoliaSearchApiKey
)

export const algoliaWriteClient = algoliasearch(
  process.env.NEXT_PUBLIC_ALGOLIA_APP_ID,
  process.env.NEXT_PUBLIC_ALGOLIA_WRITE_API_KEY
)

export const algoliaSearchIndex =
  algoliaWriteClient.initIndex(algoliaSearchIndexId)

export const algoliaSearchIndices = {
  stage: [
    { value: 'ascd_stage', label: 'Default' },
    { value: 'ascd_stage_title_asc', label: 'Title (asc)' },
    { value: 'ascd_stage_title_desc', label: 'Title (desc)' },
    { value: 'ascd_stage_article_date_asc', label: 'Date Created (asc)' },
    {
      value: 'ascd_stage_article_date_desc',
      label: 'Date Created (desc)',
    },
    {
      value: 'ascd_stage_book_release_asc',
      label: 'Books - Date Released (asc)',
    },
    {
      value: 'ascd_stage_book_release_desc',
      label: 'Books - Date Released (desc)',
    },
    {
      value: 'ascd_stage_workshop_startDate_asc',
      label: 'Workshops - First Start Date (asc)',
    },
    {
      value: 'ascd_stage_workshop_startDate_desc',
      label: 'Workshops - First Start Date (desc)',
    },
  ],
  master: [
    { value: 'ascd_master', label: 'Default' },
    { value: 'ascd_master_title_asc', label: 'Title (asc)' },
    { value: 'ascd_master_title_desc', label: 'Title (desc)' },
    { value: 'ascd_master_article_date_asc', label: 'Date Created (asc)' },
    {
      value: 'ascd_master_article_date_desc',
      label: 'Date Created (desc)',
    },
    {
      value: 'ascd_master_book_release_asc',
      label: 'Books - Date Released (asc)',
    },
    {
      value: 'ascd_master_book_release_desc',
      label: 'Books - Date Released (desc)',
    },
    {
      value: 'ascd_master_workshop_startDate_asc',
      label: 'Workshops - First Start Date (asc)',
    },
    {
      value: 'ascd_master_workshop_startDate_desc',
      label: 'Workshops - First Start Date (desc)',
    },
  ],
}
